<label class="sas-checkbox {{sasClass}}" [for]="instanceId">
  <input #fieldModel="ngModel"
         class="form-check-input check"
         type="checkbox"
         [attr.aria-readonly]="sasReadonly"
         [attr.aria-labelledby]="instanceId + 'Label'"
         [attr.aria-describedby]="instanceId + 'Desc'"
         [checked]="isChecked"
         [disabled]="sasDisabled"
         [id]="instanceId"
         [name]="name"
         [title]="sasHelptext | translate"
         [value]="value"
         [(ngModel)]="value"
         (change)="action($event)" />
  <span class="form-check-label"
        [id]="instanceId + 'Label'"
        [title]="sasHelptext | translate"
        translate="{{label}}">
  </span>
  <div class="sas-inline-block"
       [id]="instanceId + 'Desc'"
       [title]="sasHelptext | translate">
    @if (sasHelptext) {
    <i class="bi bi-info-circle-fill sas-info-icon" aria-hidden="true"></i>
  }
  </div>
</label>
